export default __webpack_public_path__ + "static/media/institute-28-min.ccee0d05.webp";